export default "__VITE_ASSET__DNbXQ9He__"